import React, { useState } from "react";
import { useLocalizedStrings } from "../Localization";
import U2NETIMG from "../assets/U2NETPR.png";
import tuylu from "../assets/Figure_1.png";
import golge from "../assets/Figure_3.png";
import sample1 from "../assets/Figure_2.png";
import sample2 from "../assets/Figure_4.png";
import Segmentation from "./ClothSegmentation";


const ProjectSegmentation = () => {
  const strings = useLocalizedStrings();
  const [image, setImage] = useState(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-gray-900">
      <div className="max-w-4xl mx-auto p-10 bg-white shadow-lg rounded-lg">
        <h1 className="text-3xl font-bold mb-4 text-center">
          Giysi Semantik Segmentasyonu Projesi
        </h1>
        
        <p className="mb-4">
          Giysi semantik segmentasyonu, bilgisayarlı görü alanında önemli bir araştırma konusudur ve moda, e-ticaret ile sanal giyinme uygulamalarında geniş bir kullanım alanına sahiptir.
        </p>
        <Segmentation />
        <h2 className="text-2xl font-semibold mt-6 mb-2">Projenin Amacı</h2>
        <p className="mb-4">
          Proje, giysi içeren bir fotoğrafı girdi olarak alıp, giysinin maskeleme ve kırpma işlemlerini gerçekleştirerek çıktı olarak sunmayı hedeflemektedir. Bu işlem, özellikle sanal giyinme ve moda analiz uygulamalarında büyük önem taşımaktadır.
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-2">Kullanılan Yöntemler ve Teknolojiler</h2>
        <h3 className="text-xl font-semibold mt-4">Derin Öğrenme Mimarisi: U^2-Net</h3>
        <p className="mb-4">
          Projede, giysi segmentasyonu için U^2-Net mimarisi kullanılmıştır. U^2-Net, özellikle nesne tespiti ve segmentasyon görevlerinde yüksek performans gösteren bir derin öğrenme modelidir.
        </p>
        <img className="w-[70%] m-auto"  src={U2NETIMG} alt="U2NET Architect" />
        <h3 className="text-xl font-semibold mt-4">Veri Seti: iMaterialist</h3>
        <p className="mb-4">
          Model, Kaggle platformunda bulunan iMaterialist veri seti kullanılarak eğitilmiştir. Bu veri seti, moda ve giysi segmentasyonu alanında geniş çaplı ve çeşitli örnekler içermektedir.
          <br />
          <a href="https://www.kaggle.com/c/imaterialist-fashion-2020-fgvc7"  className="text-blue-500 underline pr-1"> iMaterialist Dataset Kaggle</a>
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-2">Gerekli Kütüphaneler ve Kurulum</h2>
        <ul className="list-disc list-inside mb-4">
          <li>Python 3.8 veya üzeri</li>
          <li>Torch 2.1.1</li>
          <li>Torchvision 0.16.1</li>
          <li>Numpy 1.24.4</li>
          <li>OpenCV-Python 3.8.1.78</li>
          <li>Matplotlib 3.7.4</li>
        </ul>
        <h2 className="text-2xl font-semibold mt-6 mb-2">Sonuçlar ve Değerlendirme</h2>
        <p className="mb-4">
          Proje kapsamında gerçekleştirilen giysi segmentasyonu işlemlerinde bazı zorluklarla karşılaşılmıştır:
        </p>
        <ul className="list-disc list-inside mb-4">
          
          <li><strong>Tüylü Yapılar:</strong> Giysinin tüylü yapıya sahip olması, kenarlarda renk karışmalarına neden olmuştur.</li>
          <img src={tuylu} alt="" /> <p className="text-gray-700 italic text-center">Şekil-2 Tüylü kıyafetlerin kenarları çok dalgalı olmasından kaynaklı birebir tanımlama yapılamamıştır..</p> <br /><br />
          <li><strong>Gölge Etkisi:</strong> Giysinin alt kısmında oluşan gölgeler, modelin yanılmasına sebep olmuştur.</li>
          <li><strong>Arka Plan Benzerlikleri:</strong> Giysi kenarlarıyla paralel arka plan çizgileri, modelin hatalı segmentasyon yapmasına yol açmıştır.</li>
          <img src={golge} alt="" />  <p className="text-gray-700 italic text-center">Şekil-3 Gölge ve arka plan benzerlikleri sonucu hatalı geri dönüş.</p> <br />
        </ul>
        <h2 className="text-2xl font-semibold mt-6 mb-2">Doğru Sonuç örnekleri</h2>
        <img src={sample1} alt="" />   
        <img src={sample2} alt="" />  
        <h2 className="text-2xl font-semibold mt-6 mb-2">Sonuç ve Gelecek Çalışmalar</h2>
        <p>
          <a href="https://github.com/oyelmali/Cloth-Semantic-Segmentation" className="text-blue-500 underline pr-1">
            Oyelmali/Cloth-Semantic-Segmentation 
          </a> 
          projesi, giysi segmentasyonu alanında önemli bir adım olup, sanal giyinme ve moda teknolojileri gibi uygulamalarda potansiyel kullanım alanlarına sahiptir. Gelecekte, modelin daha karmaşık arka planlar ve farklı giysi türleriyle eğitilerek performansının artırılması hedeflenmektedir.
        </p>
        
      </div>
    </div>
  );
};

export default ProjectSegmentation;
